cb.define([], function () { //编辑 新增 商品模板
  var PC_pc_producttpllist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      
      viewmodel.on('beforeAdd', function(args){
        if(args.params.params && args.params.params.params 
          && args.params.params.params.index > -1){
          //复制
          args.params.carryParams.id = viewmodel.getGridModel().getCellValue(
            args.params.params.params.index,"id");
        }
      });
      
    }
  }
  try {
    module.exports = PC_pc_producttpllist_VM_Extend;
  } catch (error) {
 
  }
  return PC_pc_producttpllist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_producttpllist_VM.Extend.js